import type {
  TimeseriesInstrumentDataResponse,
  TimeseriesInstrumentListResponse,
  TimeseriesInstrumentStatisticsResponse,
  TimeseriesInstrumentSyncUpdateRequest,
  TimeseriesInstrumentSyncUpdateResponse,
} from "@repo/shared/types";
import { get, patch } from "@/lib/api/_client";

const BASE = "/internal/admin/timeseries";

export function listInstruments(params: {
  source?: string;
  search?: string;
  status?: string;
  page?: number;
  perPage?: number;
}): Promise<TimeseriesInstrumentListResponse> {
  const qs = new URLSearchParams();
  if (params.source) qs.set("source", params.source);
  if (params.search) qs.set("search", params.search);
  if (params.status) qs.set("status", params.status);
  qs.set("page", String(params.page ?? 1));
  qs.set("perPage", String(params.perPage ?? 50));
  return get(`${BASE}?${qs.toString()}`);
}

/** Raw stored data points for one instrument, for the admin inspect dialog. */
export function getInstrumentData(
  source: string,
  ticker: string,
): Promise<TimeseriesInstrumentDataResponse> {
  return get(`${BASE}/${encodeURIComponent(source)}/${encodeURIComponent(ticker)}/data`);
}

/** Calendar statistics of the stored series as it is — no patch, no conversion (QL-706). */
export function getInstrumentStatistics(
  source: string,
  ticker: string,
): Promise<TimeseriesInstrumentStatisticsResponse> {
  return get<TimeseriesInstrumentStatisticsResponse>(
    `${BASE}/${encodeURIComponent(source)}/${encodeURIComponent(ticker)}/statistics`,
  );
}

export function setInstrumentSyncEnabled(
  source: string,
  ticker: string,
  enabled: boolean,
): Promise<TimeseriesInstrumentSyncUpdateResponse> {
  return patch(`${BASE}/${encodeURIComponent(source)}/${encodeURIComponent(ticker)}/sync`, {
    enabled,
  } satisfies TimeseriesInstrumentSyncUpdateRequest);
}
